import { gql } from "@apollo/client"

export const ADD_UPDATE_PRODUCTION = gql`
  mutation AddUpdateProduction($input: ProductionUpsertInput!) {
    addUpdateProduction(input: $input) {
      ok
      error
      production {
        id
      }
    }
  }
`

export const UPDATE_LINE_PACKING_ALLOTMENT_LOT_CODE = gql`
  mutation updateLinePackingAllotmentLotCode(
    $input: UpdateLinePackingAllotmentLotCodeInput!
  ) {
    updateLinePackingAllotmentLotCode(input: $input) {
      ok
      message
    }
  }
`
